import React, { memo } from 'react';
import { string, shape, func, bool } from 'prop-types';

const IconWithText = ({
  icon: Icon,
  text,
  onClick,
  iconClassName,
  className,
  textClassName,
  textOnLeft,
  active,
  testId,
}) => {
  return (
    <span
      className={`text-xs items-center flex truncate ${
        textOnLeft ? 'lg:flex-row-reverse' : 'lg:flex-row'
      } ${
        active ? 'text-brand-primary' : 'text-javelin-gray-light'
      } ${className}`}
      onClick={onClick}
      data-testid={testId}
    >
      <Icon className={`${iconClassName} fill-current flex-shrink-0`} />
      <p className={`${textClassName} lg:mr-1 truncate select-none`}>{text}</p>
    </span>
  );
};

IconWithText.propTypes = {
  icon: shape({}).isRequired,
  text: string,
  onClick: func,
  iconClassName: string,
  className: string,
  textClassName: string,
  textOnLeft: bool,
  active: bool,
  testId: string,
};
IconWithText.defaultProps = {
  text: '',
  onClick: () => null,
  iconClassName: 'h-4',
  className: 'h-14',
  textClassName: 'ml-5',
  textOnLeft: false,
  active: false,
  testId: 'icon-with-text',
};

export default memo(IconWithText);
